export default __webpack_public_path__ + "static/media/Capa_1.369a46c9.svg";